import type { ILanguageResources, ITranslationModule } from '../../../../interfaces';
import { interpolate } from '../../../../global';

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.dashboard.widget.SalesSuccessWidget.';
  public static readonly convertedQuote = `${Id.prefix}convertedQuote`;
  public static readonly unconvertedQuote = `${Id.prefix}unconvertedQuote`;
  public static readonly salesSuccess = `${Id.prefix}salesSuccess`;
  public static readonly conversionQuoteToOrder = `${Id.prefix}conversionQuoteToOrder`;
}

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class LangSalesSuccessWidget {
  private constructor() {}
  public static convertedQuote(): string {
    return interpolate(Id.convertedQuote);
  }
  public static unconvertedQuote(): string {
    return interpolate(Id.unconvertedQuote);
  }
  public static salesSuccess(): string {
    return interpolate(Id.salesSuccess);
  }
  public static conversionQuoteToOrder(): string {
    return interpolate(Id.conversionQuoteToOrder);
  }
}

export class SalesSuccessWidgetModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.convertedQuote, "Converted {{glossary 'quote:plural'}}", 'Label for converted quotes in chart');
    register.add(
      Id.unconvertedQuote,
      "Unconverted {{glossary 'quote:plural'}}",
      'Label for unconverted quotes in chart'
    );
    register.add(Id.salesSuccess, 'Sales Success', 'Header for sales success widget');
    register.add(
      Id.conversionQuoteToOrder,
      "Conversion {{glossary 'quote:plural'}} to {{glossary 'order:plural'}}",
      'Conversion label in widget'
    );
  }
}
